
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 61 59","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59.95 29.5a29.36 29.36 0 01-6.574 18.502 29.759 29.759 0 01-16.811 10.32 29.93 29.93 0 01-19.616-2.428 29.603 29.603 0 01-13.744-14.1A29.295 29.295 0 011.41 22.259 29.488 29.488 0 0112.358 5.924 29.88 29.88 0 0131.208.016a29.853 29.853 0 0118.415 7.132c.41.337.796.692 1.177 1.058a29.275 29.275 0 013.617 4.164c.082.105.156.211.234.321a29.17 29.17 0 015.298 16.81z","fill":"#FE8700"}}),_c('path',{attrs:{"d":"M59.95 29.5a29.36 29.36 0 01-6.574 18.502 29.759 29.759 0 01-16.811 10.32 29.93 29.93 0 01-19.616-2.428 29.603 29.603 0 01-13.744-14.1A29.295 29.295 0 011.41 22.259 29.488 29.488 0 0112.358 5.924 29.88 29.88 0 0131.208.016a29.853 29.853 0 0118.415 7.132c.41.337.796.692 1.177 1.058a29.275 29.275 0 013.617 4.164c.082.105.156.211.234.321a29.17 29.17 0 015.298 16.81z","fill":"#FE8700"}}),_c('path',{attrs:{"d":"M59.322 5.459l-4.897 6.919a29.46 29.46 0 00-4.777-5.206l4.002-5.657a3.49 3.49 0 014.833-.84 3.423 3.423 0 01.847 4.797l-.008-.013z","fill":"#FE8700"}}),_c('path',{attrs:{"d":"M54.426 12.378L34.777 40.14l-2.317 3.256a2.692 2.692 0 01-1.968 1.12 2.718 2.718 0 01-2.133-.766L14.88 30.413a3.445 3.445 0 01-1.022-2.443 3.424 3.424 0 011.022-2.442l.135-.138a3.474 3.474 0 012.46-1.016 3.493 3.493 0 012.461 1.016l8.965 8.897a1.08 1.08 0 001.297.168c.136-.077.253-.183.344-.31L49.644 7.148c.41.338.783.688 1.16 1.046a29.466 29.466 0 013.618 4.16s0 .02.004.024z","fill":"#fff"}})])
          )
        }
      }
    